import React, { useState, useContext, useEffect, useMemo } from 'react'
import { Formik, Field, FieldArray, ErrorMessage } from 'formik'
import { Form, Row, Col, Button, Modal, Accordion } from 'react-bootstrap'

import { AiFillEdit } from 'react-icons/ai'
import { MdSlideshow } from 'react-icons/md'

import TableCard from '../tableCard/index.js'
import StoreContext from '../storage/context'
import AlertCustom from '../alertCustom/index.js'
import BtnLoader from '../buttons/loader/index.js'
import NavigationBar from '../navigationBar/index.js'
import onSubmitSearch from '../ILEntitiesSearch/index.js'
import IntegrationLayerEntity from '../integrationLayerEntity/index.js'
import ControlWithValidation from '../fields/controlWithValidation/index.js'
import SelectWithValidationInfo from '../fields/selectWithValidationInfo/index.js'


// schema validation
import * as schema from '../schemaValidation/index.js'

import './styles.css'


const IntegrationLayerEntitySearch = () => {
    const { token, pk_user, setToken, pk_service } = useContext(StoreContext);

    const navegation = [
        {
            'nome': 'home',
            'link': '/'
        },
        {
            'nome': 'integration layer',
            'link': `/integration-layer?service_id=${pk_service}`
        },
        {
            'nome': 'cadastrar entidade',
            'link': `/integration-layer/entidade/cadastrar`
        }
    ]

    const emptyEntity = {
        active: "true",
        chunk_size: "",
        delimiter: "",
        content_delimiter: "'",
        encoding: "",
        entity_name: "",
        extension_file: "",
        account_destination: '',
        datalake_destination: 'trusted',
        datalake_table_name: '',
        email_notification_account: '',
        header: "true",
        message: "",
        pattern_date: "",
        pattern_file: "",
        source_path: "",
        schedule_interval: "",
        schedule_delta: "",
        system_name: "",
        type_file: "",
        tag_set: [{"Key": "project", "Value": 'nome do projeto'}, {"Key": "platform", "Value": 'integration_layer'}]
    }

    const [entities, setEntities] = useState([]);
    const [fields, setFields] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [newItem, setNewItem] = useState(false);
    const [alert, setAlert] = useState({header: '', message: '', type: '', options_btn: []});

    const [readOnly, setReadOnly] = useState(false);
    const [showEntityForm, setShowEntityForm] = useState(false);
    const [entity, setEntity] = useState(emptyEntity)
    const [typeForm, setTypeForm] = useState("newEntity")
    const [loadingData, setLoadingData] = useState(false)
    const [query, setQuery] = useState({})

    useEffect(()=>{
        if (newItem) {
            setTypeForm("newEntity")
            setEntity(emptyEntity)
            setFields([])
            setShowEntityForm(true)
            setNewItem(false)
            setReadOnly(false)
        }
    }, [newItem])


    useEffect(()=> {
        var values = {
            type_query: 'scan',
            entity_name: 'teste_portal',
            system_name: '',
            condition: 'Equal to',
            filters: [
                {attribute: 'entity_name', condition: 'Exists', value: ''}
            ]
        }

        onSubmitSearch(
            values,
            setLoading,
            setLoadingData,
            setEntities,
            setQuery,
            pk_user,
            token,
            setToken,
            setAlert,
            setShowAlert
        )
    }, [])


    const handleSubmitSearch = (values) => {
        onSubmitSearch(
            values,
            setLoading,
            setLoadingData,
            setEntities,
            setQuery,
            pk_user,
            token,
            setToken,
            setAlert,
            setShowAlert
        )
    }


    const onSubmitShow = (row) => {
        const pattern_date = handleDynamoToPortal(row.pattern_date)
        const fields_custom = handleFieldsPortal(row.fields)

        setEntity({...row, pattern_date: pattern_date})
        setFields(fields_custom)
        setReadOnly(true)
        setShowEntityForm(true)
        setTypeForm("showEntity")
    }


    const onSubmitEdit = (row) => {
        const pattern_date = handleDynamoToPortal(row.pattern_date)
        const fields_custom = handleFieldsPortal(row.fields)

        setEntity({...row, pattern_date: pattern_date})
        setFields(fields_custom)
        setReadOnly(false)
        setShowEntityForm(true)
        setTypeForm("editEntity")
    }


    const handleFieldsPortal = (fields_response) => {
        const fields_custom = fields_response.map((item, index) => {
            if (item.data_type === 'date' | item.data_type === 'datetime') {
                item.mask_field = handleDynamoToPortal(item.mask_field)
            }
            return {...item, id: index}
        })

        return fields_custom
    }


    const handleDynamoToPortal = (value) => {
        // apply year conversion
        value = value.replace('%Y', 'yyyy');
        value = value.replace('%y', 'yy');

        // apply month conversion
        value = value.replace('%B', 'mmmm');
        value = value.replace('%b', 'mmm');
        value = value.replace('%m', 'mm');

        // apply day conversion
        value = value.replace('%A', 'dddd');
        value = value.replace('%a', 'ddd');
        value = value.replace('%d', 'dd');
        value = value.replace('%w', 'd');

        // apply hours conversion
        value = value.replace('%H', 'H');

        // apply minutes conversion
        value = value.replace('%M', 'M');

        // apply seconds conversion
        value = value.replace('%S', 'S');

        // apply microseconds conversion
        value = value.replace('%f', 'f');

        return value
    }


    let data = useMemo(() => entities.map((item, index) => (
		{
			id: index,
			entity_name: item.entity_name,
			system_name: item.system_name,
            account_destination: item.account_destination,
            datalake_destination: item.datalake_destination,
            ...item
		}
	)))


    const columns = useMemo(
		() => [
			{
				Header: '#',
				accessor: 'id', // accessor is the "key" in the data
			},
            {
				Header: 'entity_name',
				accessor: 'entity_name',
			},
            {
				Header: 'system_name',
				accessor: 'system_name',
			},
			{
				Header: 'account_destination',
				accessor: 'account_destination',
			},
            {
				Header: 'datalake_destination',
				accessor: 'datalake_destination',
			},
			{
				width: 100,
				Header: "Ações",
				Cell: ({ value, column, row }) => (
					<div key={row.original.id} className='mf-search-actions'>
						<MdSlideshow size={20} onClick={() => onSubmitShow(row.original)} />
						<AiFillEdit size={20} onClick={() => onSubmitEdit(row.original)} />
					</div>
				)
			}
		],
		[]
	)


    return (
        <div className="il-search-entity-container">
            <AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

            <NavigationBar navegation={navegation} />

            <EntitySearch
                handleSubmitSearch={handleSubmitSearch}
                schema={schema}
                loading={loading}
            />

            <TableCard
                data={data}
                columns={columns}
                setNewItem={setNewItem}
                flagNewItem={true}
                disableFilter={true}
                loadingData={loadingData}
            />

            <HandleEntity
                showEntityForm={showEntityForm}
                setShowEntityForm={setShowEntityForm}
                setAlert={setAlert}
                fields={fields}
                setFields={setFields}
                readOnly={readOnly}
                setShowAlert={setShowAlert}
                entity={entity}
                setEntity={setEntity}
                emptyEntity={emptyEntity}
                typeForm={typeForm}
                query={query}
                setQuery={setQuery}
                setEntities={setEntities}
                setLoadingData={setLoadingData}
            />

        </div>
    );
}


const HandleEntity = ({
    showEntityForm,
    setShowEntityForm,
    setAlert,
    fields,
    setFields,
    readOnly,
    setShowAlert,
    entity,
    setEntity,
    typeForm,
    emptyEntity,
    query,
    setQuery,
    setEntities,
    setLoadingData
}) => (
    <Modal
        dialogClassName="mfs-main-modal"
        // fullscreen={true}
        show={showEntityForm}
        onHide={() => setShowEntityForm(false)}
        aria-labelledby="example-modal-sizes-title-lg"
    >
        <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
                Informações da entidade
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <IntegrationLayerEntity
                entity={entity}
                setEntity={setEntity}
                fields={fields}
                setFields={setFields}
                setShowAlert={setShowAlert}
                setAlert={setAlert}
                readOnly={readOnly}
                typeForm={typeForm}
                emptyEntity={emptyEntity}
                setShowEntityForm={setShowEntityForm}
                query={query}
                setQuery={setQuery}
                setEntities={setEntities}
                setLoadingData={setLoadingData}
            />
        </Modal.Body>
    </Modal>
)


const EntitySearch = ({
    handleSubmitSearch,
    readOnly,
    loading,
    schema,
}) => (
    <Formik
        initialValues={{
            type_query: "query",
            entity_name: '',
            system_name: '',
            condition: "Equal to",
            filters: [{"attribute": "entity_name", "condition": "Equal to", "value": "mm_account"}, {"attribute": "system_name", "condition": "Equal to", "value": "sap_ecc"}]
        }}
        validationSchema={schema.ILSearchSchema}
        onSubmit={(values) => handleSubmitSearch(values)}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={true}
    >
    {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        setValues,
        touched,
        isValid,
        errors,
    }) => (
        <div>
        <Accordion defaultActiveKey={['1']}className="il-container-accordion">
        <Accordion.Item eventKey="0" >
        <Accordion.Header>Query/Scan Itens</Accordion.Header>
        <Accordion.Body>
        <Form noValidate onSubmit={handleSubmit} >
            <Row className="mb-3">
                <SelectWithValidationInfo
                    key="type_query"
                    Col={Col}
                    type="text"
                    label="scan/query"
                    name="type_query"
                    placeholder=""
                    value={values.type_query}
                    error={errors.type_query}
                    handleChange={handleChange}
                    options={["query", "scan"]}
                    readOnly={false}
                    typeColumn="xs"
                    valueColumn={2}
                    tooltip="Selecione entre query|scan para pesquisar no dynamodb&#0010;Obs.: De preferência pra pesquisas do tipo query, pois&#0010;irá consumir menos 'read capacity units'"
                />
                <Col xs={10}/>
            </Row>

            {values.type_query === 'query' ?
                <QuerySearch
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    readOnly={readOnly}
                />
            : null}

            {values.type_query === 'scan' ?
                <ScanSearch
                    values={values}
                    setValues={setValues}
                    errors={errors}
                    handleChange={handleChange}
                    readOnly={readOnly}
                    touched={touched}
                />
            : null}

            <div className="mf-register-next">
                <BtnLoader
                    loading={loading}
                    messageNotLoading="Run"
                    messageLoading="Running..."
                    style={"btn-loader-135px"}
                    variant={"secondary"}
                    hasOnClick={true}
                />
            </div>
        </Form>
        </Accordion.Body>
        </Accordion.Item>
        </Accordion>
        </div>
    )}
    </Formik>
)


const QuerySearch = ({values, errors, handleChange, readOnly}) => (
    <div>
        <Row className="mb-3">
            <ControlWithValidation Col={Col}
                type="text"
                label="entity_name (Partition Key)"
                name="entity_name"
                placeholder="Enter partition key value"
                value={values.entity_name}
                error={errors.entity_name}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={5}
            />
            <Col xs={3}/>
        </Row>

        <Row className="mb-3">
            <Col>
                <Form.Group as={Col} controlId="system_name">
                    <Form.Label>system_name (Sort Key)</Form.Label>
                    <div className='il-search-system-name-container'>
                        <div className='il-search-system-name-condition'>
                            <Form.Select
                                type="text"
                                name="condition"
                                placeholder=""
                                value={values.condition}
                                onChange={handleChange}
                                isInvalid={!!errors.condition}
                                disabled={readOnly}
                            >
                                {[
                                    "Equal to",
                                    "Less than or equal to",
                                    "Less than",
                                    "Greater than or equal to",
                                    "Greater than",
                                    "Between",
                                    "Begins with"].map((item, index) => (<option value={item}>{item}</option>))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {errors.condition}
                            </Form.Control.Feedback>
                        </div>
                        <div className='il-search-system-name'>
                            <Form.Control
                                type="text"
                                name="system_name"
                                placeholder="Enter sort key value"
                                value={values.system_name}
                                onChange={handleChange}
                                isInvalid={!!errors.system_name}
                                readOnly={readOnly}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.system_name}
                            </Form.Control.Feedback>
                        </div>
                    </div>
                </Form.Group>
            </Col>

            <Col xs={3}/>
        </Row>
    </div>
)


const ScanSearch = ({ values, setValues, errors, touched, handleChange, readOnly }) => {
    const onAddNewTag = () => {
        const filters = [...values.filters];
        filters.push({attribute: '', condition: 'Equal to', value: ''})
        setValues({ ...values, filters });
    }

    const onRemoveTag = (index, item) => {
        const filters = values.filters.filter(function(value, index_, arr){ 
            return index_ != index;
        });
        setValues({ ...values, filters });
    }

    return ( 
        <div className='ilr-container-tags'>
            <FieldsWithoutLabel
                onRemoveTag={onRemoveTag}
                values={values}
                errors={errors}
                handleChange={handleChange}
                readOnly={readOnly}
                touched={touched}
            />

            <Button className='btn-icon-text btn-next' variant="light" onClick={onAddNewTag}>
                Add filter
            </Button>
        </div>
    )
}


const FieldsWithoutLabel = ({ onRemoveTag, values, errors, touched, readOnly }) => (
    <FieldArray name="filters">
        {() => (values.filters.map((tags, i) => {
            const tagsErrors = errors.filters?.length && errors.filters[i] || {};
            const tagsTouched = touched.filters?.length && touched.filters[i] || {};
            return (
                <div>
                    {i === 0 ?
                    <div>
                        {/* <Row className="mb-3">
                            <p>Filters</p>
                        </Row> */}
                        <Row className="mb-3">
                            <Col md>
                                <label>Attribute name</label>
                            </Col>
                            <Col md>
                                <label>Condition</label>
                            </Col>
                            <Col md>
                                <label>Value</label>
                            </Col>
                            <Col md />
                        </Row>
                    </div>
                    : null}

                    <Row className="mb-3">                     
                        <Col md>
                            <Field name={`filters.${i}.attribute`} placeholder="Enter attribute name" type="text" className={'form-control' + (tagsErrors.attribute && tagsTouched.attribute ? ' is-invalid' : '' )} />
                            <ErrorMessage name={`filters.${i}.attribute`} component="div" className="invalid-feedback" />
                        </Col>
                        <Col md>
                            <Field component="select" name={`filters.${i}.condition`} type="select" className={'form-select' + (tagsErrors.condition && tagsTouched.condition ? ' is-invalid' : '' )}>
                                {[
                                    "Equal to",
                                    "Not equal to",
                                    "Contains",
                                    "Less than or equal to",
                                    "Less than",
                                    "Greater than or equal to",
                                    "Greater than",
                                    "Between",
                                    "Begins with",
                                    "Exists",
                                    "Not exists"].map((item, index) => (<option value={item}>{item}</option>))}
                            </Field>
                            <ErrorMessage name={`filters.${i}.condition`} component="div" className="invalid-feedback" />
                        </Col>
                        <Col md>
                            <Field name={`filters.${i}.value`} placeholder="Enter attribute value" type="text" className={'form-control' + (tagsErrors.value && tagsTouched.value ? ' is-invalid' : '' )} />
                            <ErrorMessage name={`filters.${i}.value`} component="div" className="invalid-feedback" />
                        </Col>
                        <Col md>
                            <Button className='btn-tag-remove-without-label' variant="light" onClick={() => onRemoveTag(i, tags)}>
                                Remover
                            </Button>
                        </Col>
                    </Row>
                </div>
            );
        }))}
    </FieldArray>
)


export default IntegrationLayerEntitySearch;
